export const iconFontAwesomeDevicesHardwareDesktop = (
	<i className="fa-solid fa-desktop"></i>
);
